module.exports = __webpack_public_path__ + "img/Collaboration-2022.4131f8c0.png";